<template>
  <SimonModal
    :is-visible="showModal"
    @hide="showModal = false"
    id="app-tariff-option-cancel-modal"
    custom-modal-class="tariffModal"
    size="large"
    close-button-color="light"
    show-footer-buttons
    :btn-right-title="getSlotText('btnCancel', 'Wech damit!')"
    @btnLeft="showModal = false"
    @btnRight="cancelOption"
    sticky-header
  >
    <template v-slot:modalTitle>
      <div class="box-head-left">
        <div class="box-head-title">
          <h4>{{ option.name }}</h4></div>
        <div class="box-head-data"><h4>{{ formattedIncentive }}</h4></div>
      </div>
      <div class="box-head-right">
        <div class="box-head-price">
          <span>{{ formattedPrice }}</span>
        </div>
        <div class="box-head-price-data">
          <span class="price--cur">&euro;</span>
          <span class="price--period">
          <slot name="txtPeriodAbo" v-if="option.automaticExtension">monatlich</slot>
          <slot name="txtPeriodOnetime" v-else>einmal</slot>
        </span>
        </div>
      </div>
    </template>
    <div class="option-modal--body">
      <div class="info">
        <slot name="txtCancelModal"></slot>
      </div>
      <div v-if="showDocument !== false" class="contract-summary">
        <slot name="lblCancelContractSummaryPreModal">CancelContractSummaryPre</slot>&nbsp;
        <span class="download-link" @click="downloadDocumentWithAuth" ><slot name="lblCancelContractSummaryModal">CancelContractSummary</slot></span>&nbsp;
        <slot name="lblCancelContractSummaryPostModal">CancelContractSummaryPost</slot>
      </div>
    </div>
    <div v-if="gotBackendError" v-html="getBackendErrorMessage" class="error-box"></div>
  </SimonModal>
</template>
<script>

import price from '@/mixins/formatters/price'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import transaction from '@/mixins/transaction'
import beErrors from '@/mixins/beErrors'
import { mapActions, mapGetters } from 'vuex'

import axios from 'axios'
import FileSaver from 'file-saver'
import appFileSaver from '@/mixins/appFileSaver'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'TariffOptionCancelModal',
  components: { SimonModal },
  data () {
    return {
      showModal: false,
      showDocument: false,
      errorMsg: false,
      gotBackendError: false,
      loading: false
    }
  },
  methods: {
    ...mapActions('tariffOptions', [
      'cancelTariffoption',
      'confirmCancelTariffoption'
    ]),
    cancelOption () {
      this.gotBackendError = false
      this.loading = true
      this.startLoader()

      this.confirmCancelTariffoption({})
        .then((response) => {
          if (response.success === true) {
            this.showModal = false
            this.successToast(
              this.$slots.txtCancelTariffOptionSuccess
                ? this.$slots.txtCancelTariffOptionSuccess[0].text
                : 'Die Option wurde erfolgreich gebucht. In kurzer Zeit wird diese auch im Kundenportal angezeigt.'
            )
            this.gotBackendError = false
            this.errorMsg = ''
            this.trackOption('confirmation')
          }
        })
        .catch(() => {
          this.showModal = true
          this.gotBackendError = true
          this.triggerErrorTracking()
        })
        .finally(() => {
          this.loading = false
          this.stopLoader()
        })
    },
    initializeCancelOption () {
      if (!this.initializeOptionStarted) {
        this.gotBackendError = false
        this.$emit('update:gotBackendErrorInitiate', false)
        this.initializeOptionStarted = true
        this.startLoader()

        this.cancelTariffoption({ tariffoptionId: this.option.tariffoptionId })
          .then((response) => {
            if (response.success) {
              this.showDocument = response.cancelTariffoptionDocumentUrl || false
              this.showModal = true
              this.$emit('update:gotBackendErrorInitiate', false)
              this.trackOption('summary')
            }
          })
          .catch(() => {
            this.showModal = false
            this.$emit('update:gotBackendErrorInitiate', true)
            this.triggerErrorTracking()
          })
          .finally(() => {
            this.initializeOptionStarted = false
            this.stopLoader()
          })
      }
    },
    downloadDocumentWithAuth (e) {
      if (e.preventDefault) e.preventDefault()
      if (e.stopPropagation) e.stopPropagation()
      const me = this
      this.errorMsg = false

      axios.get(this.showDocument, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/octet-stream'
        },
        responseType: 'blob'
      }).then((response) => {
        const filename = 'Vertragszusammenfassung.pdf'
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        if (this.appTriggerSaveAsFileAvailable()) {
          this.appTriggerSaveAsFile(filename, file)
        } else {
          FileSaver.saveAs(file, filename)
        }
      }).catch((reason) => {
        this.errorMsg = this.getSlotText('errorNoContractDocumentAvailable', 'Ufff! Leider kann dat Dokument gerade nicht geladen werden (Fehler: VD1). Bitte probier\'s später noch einmal.')
        this.gotBackendError = true
        this.loading = false
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    },
    trackOption (stepName) {
      const data = {
        page_levels: [
          'mein-simon',
          'uebersicht',
          'option cancellation',
          stepName
        ],
        login_status: 'logged in',
        page_type: 'self service',
        platform_type: 'browser view',
        form: {
          name: 'cancel option',
          step: stepName === 'summary' ? '1' : '2',
          step_name: stepName,
          context: this.option.name + ' ' + this.formattedIncentive,
          type: 'ecare'
        }
      }
      if (stepName === 'confirmation') {
        data.form.status = 'success'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('pageview', data)
      }
    },
    triggerErrorTracking () {
      const errMsg = this.getBackendErrorMessage
      if (errMsg !== null) {
        const data = {
          type: 'technical',
          message: errMsg.substring(0, 50),
          code: String(this.beErrorGetLastErrorCode())
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    getBackendErrorMessage: function () {
      if (this.errorMsg !== false) {
        return this.errorMsg
      }
      return this.beErrorGetLastMessage()
    },
    formattedPrice () {
      return this.formatDecimal(this.option.price / 100, 2) || '0,00'
    },
    formattedIncentive () {
      return this.option.volumes[0].amount + ' ' + this.option.volumes[0].formattedUnit
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    gotBackendErrorInitiate: {
      type: Boolean,
      default: false
    }
  },
  mixins: [

    beErrors,
    price,
    formatDecimal,
    transaction('tariffOptions'),
    appFileSaver
  ]
}
</script>
